import axios, { AxiosResponse } from "axios";
import { BidData } from "../../../api-types/job-requests/bids";
import { bidUrl } from "../../utils";

export const fetchBid = (bidId: string): Promise<AxiosResponse<BidData>> => {
  return axios.get(bidUrl(bidId));
};
